// No local state needed; view mode is controlled by parent

export default function GridPosts({ viewMode, setViewMode }) {
  
  const handleViewChange = (mode) => {
    setViewMode(mode);
  };

  return (
    <div className="createPost">
      <div
        className="createPost_header"
        style={{ justifyContent: "flex-start" }}
      >
        <div className="left_header_grid">Publication</div>
      </div>
      <div className="create_splitter"></div>
    <div className="createPost_body grid2">
        <div 
          className={`view_type ${viewMode === 'list' ? 'active' : ''}`}
          onClick={() => handleViewChange('list')}
          style={{ cursor: 'pointer' }}
        >
      <i className={`list_icon ${viewMode === 'list' ? 'filter_blue' : ''}`}></i>
          List view
        </div>
        <div 
          className={`view_type ${viewMode === 'grid' ? 'active' : ''}`}
          onClick={() => handleViewChange('grid')}
          style={{ cursor: 'pointer' }}
        >
      <i className={`grid_icon ${viewMode === 'grid' ? 'filter_blue' : ''}`}></i>
          Grid view
        </div>
      </div>
    </div>
  );
}
